<template>
  <div>
    <template v-if="!hasSub">
      <a v-if="url?.toLowerCase()?.substr(0, 4) === 'http'" :href="url" @click="setCurrentPath()" :class="[this.getRouteClass()]" class="d-flex justify-content-between align-items-center" v-bind="$attrs">
        <div v-if="icon" class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center nav-icon-style">
          <font-awesome-icon :icon="icon" />
        </div>
        <span class="nav-link-text w-100 text-wrap" :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'">{{ navText }}</span>
        <font-awesome-icon v-if="hasSub" icon="fa-solid fa-angle-down" />
      </a>

      <router-link v-else :to="url" @click="setCurrentPath()" :class="[this.getRouteClass()]" class="d-flex justify-content-between align-items-center" v-bind="$attrs">
        <div v-if="icon" class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center nav-icon-style">
          <font-awesome-icon :icon="icon" />
        </div>
        <span class="nav-link-text w-100 text-wrap" :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'">{{ navText }}</span>
        <font-awesome-icon v-if="hasSub" icon="fa-solid fa-angle-down" />
      </router-link>
    </template>

    <template v-else>
      <div v-if="hasSub" :to="url" @click="setCurrentPath()" :class="[this.getRouteClass()]" class="d-flex justify-content-between align-items-center" v-bind="$attrs">
        <div v-if="icon" class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center nav-icon-style">
          <font-awesome-icon :icon="icon" />
        </div>
        <span class="nav-link-text w-100 text-wrap" :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'">{{ navText }}</span>
        <font-awesome-icon v-if="hasSub" icon="fa-solid fa-angle-down" />
      </div>
      <template v-if="!hasSub">
        <a v-if="url.toLowerCase()?.substr(0, 4) === 'http'" :href="url" :class="[this.getRouteClass()]" class="d-flex justify-content-between align-items-center" v-bind="$attrs">
          <div v-if="icon" class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center nav-icon-style">
            <font-awesome-icon :icon="icon" />
          </div>
          <span class="nav-link-text w-100 text-wrap" :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'">{{ navText }}</span>
          <font-awesome-icon v-if="hasSub" icon="fa-solid fa-angle-down" />
        </a>
        <router-link v-else :to="url" :class="[this.getRouteClass()]" @click="setCurrentPath()" class="d-flex justify-content-between align-items-center" v-bind="$attrs">
          <div v-if="icon" class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center nav-icon-style">
            <font-awesome-icon :icon="icon" />
          </div>
          <span class="nav-link-text w-100 text-wrap" :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'">{{ navText }}</span>
          <font-awesome-icon v-if="hasSub" icon="fa-solid fa-angle-down" />
        </router-link>
      </template>
    </template>
  </div>
</template>
<style lang="sass">
.nav-link-custom
  color: #6E7377 !important
</style>
<script>
export default {
  name: "sidenav-item",
  props: {
    hasSub: {
      type: Boolean,
      default: false,
    },
    isSub: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
    url: {
      type: String,
      required: true
    },
    navText: {
      type: String,
      required: true
    }
  },
  methods: {
    setCurrentPath() {
      this.$store.state.currentPath = this.url;
    },
    getRouteClass() {
      const routeArr = this.$route.path;
      return {
        "ps-5": this.isSub,
        "nav-link nav-link-custom": true,
        "active": !this.hasSub && (routeArr.startsWith(this.url) || this.$store.state.currentPath.startsWith(this.url)),
      }
    }
  }
};
</script>

<style scoped>
.nav-icon-style {
  opacity: 0.3;
  color: #0385F3!important;
}
.active {
  background-color: #D9EAFE!important;
  color: #0b5ed7!important;
}
</style>